import React, { useRef } from "react";
import { Icon } from "semantic-ui-react";
import PropTypes from "prop-types";
import { onError, onSuccess } from '../messages';
import { UploadFile } from '../../../api/services/pms'
import { useLoader } from "../../../hooks/useLoader";

const FileUploader = ({ documentSpec, onUploadComplete }) => {
    const hiddenFileInputRef = useRef(null);
    const loader = useLoader()

    const handleFileUpload = async (event) => {
        event.preventDefault();
        const files = hiddenFileInputRef.current?.files;
        if (files.length > 0) {
            loader(true)
            for (const file of files) {
                const formData = new FormData();
                formData.append('EntityTypeID', documentSpec.entityTypeId);
                formData.append('EntityID', documentSpec.entityId);
                formData.append(
                    'Name',
                    window.btoa(unescape(encodeURIComponent(file.name)))
                );
                formData.append(
                    'Description',
                    window.btoa(unescape(encodeURIComponent(file.name)))
                );
                formData.append('files', file); 

                try {
                    await UploadFile(formData);
                    onUploadComplete()
                    onSuccess('FileUploadedSuccessfully');
                } catch (error) {
                    onError(error);
                }
            }
            loader(false)
        }
    };

    return <div
        onClick={() => hiddenFileInputRef.current.click()}
        style={{
            height: '100%',
            width: '100%',
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
        }}
    >
        <Icon className='upload' fitted size='large' />
        <input
            type='file'
            id='file'
            ref={hiddenFileInputRef}
            onChange={handleFileUpload}
            onClick={(e) => (e.target.value = null)}
            style={{ display: 'none' }}
            multiple
        />
    </div>
}
FileUploader.propTypes = {
    documentSpec: PropTypes.object,
    onUploadComplete: PropTypes.func
}
export default FileUploader;